(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["th-home-design"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.thHomeStarted || !document.body.classList.contains('th-home')) return;
    window.thHomeStarted = true;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const wide = matchMedia('(min-width: 750px)');
    const enabled = document.body.dataset.thMotion !== 'off';
    const motion = () => enabled && !reduced.matches && !window.Shopify?.designMode;
    const animations = new Set();
    const viewed = new WeakSet();
    let observer;
    if ('IntersectionObserver' in window) observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        if (!motion() || !entry.target.animate) continue;
        const animation = entry.target.animate([{ opacity:.35, transform:'translateY(26px)' }, { opacity:1, transform:'translateY(0)' }], { duration:850, easing:'cubic-bezier(.2,.65,.2,1)', delay:Number(entry.target.dataset.thDelay || 0) });
        animations.add(animation);
        entry.target.classList.add('th-reveal-running');
        animation.finished.catch(() => {}).finally(() => { animations.delete(animation); entry.target.classList.remove('th-reveal-running'); });
      }
    }, { threshold:.06 });
    const carousels = new Map();
    const init = (root = document) => {
      root.querySelectorAll('.range-card,.fp__body,.rg__copy,.section-header,.media-with-text__content,.shopify-section--rich-text .prose,.newsletter-content').forEach((el,index) => {
        if (viewed.has(el)) return;
        viewed.add(el);
        el.dataset.thDelay = String(el.classList.contains('range-card') ? (index % 3) * 80 : 0);
        observer?.observe(el);
      });
      root.querySelectorAll('[data-th-carousel-controls]').forEach(control => {
        if (carousels.has(control)) return;
        const section = control.closest('.shopify-section');
        const track = section?.querySelector(control.dataset.thCarouselControls);
        if (!track) return;
        const prev = control.querySelector('[data-prev]');
        const next = control.querySelector('[data-next]');
        const update = () => {
          const end = track.scrollWidth - track.clientWidth;
          control.toggleAttribute('data-active',end > 4);
          prev.disabled = track.scrollLeft < 3;
          next.disabled = track.scrollLeft >= end - 3;
        };
        const abort = new AbortController();
        const options = { signal:abort.signal };
        [prev,next].forEach((button,i) => button.addEventListener('click', () => track.scrollBy({left:(i ? 1 : -1) * track.clientWidth * .88,behavior:reduced.matches ? 'instant' : 'smooth'}),options));
        track.addEventListener('scroll',update,{...options,passive:true});
        const resize = new ResizeObserver(update);
        resize.observe(track);
        carousels.set(control,{resize,abort});
        update();
      });
      refreshMedia();
    };
    let media = [];
    let frame = 0;
    const refreshMedia = () => {
      media = [...document.querySelectorAll('.th-hero,.fp__media,.rg__media')];
      media.forEach(el => { if (!el.classList.contains('th-hero')) el.classList.add('th-parallax-media'); });
      requestTick();
    };
    const draw = () => {
      frame = 0;
      const active = motion() && wide.matches;
      for (const el of media) {
        if (!active) { el.style.removeProperty('--th-drift'); continue; }
        const r = el.getBoundingClientRect();
        if (r.bottom < -80 || r.top > innerHeight + 80) continue;
        const shift = Math.max(-12,Math.min(12,(innerHeight/2-r.top-r.height/2)*.035));
        el.style.setProperty('--th-drift',`${shift.toFixed(2)}px`);
      }
    };
    const requestTick = () => { if (!frame) frame = requestAnimationFrame(draw); };
    addEventListener('scroll',requestTick,{passive:true});
    addEventListener('resize',requestTick,{passive:true});
    reduced.addEventListener('change',() => { if (reduced.matches) animations.forEach(a => a.cancel()); requestTick(); });
    wide.addEventListener('change',requestTick);
    document.addEventListener('shopify:section:load',e => init(e.target));
    document.addEventListener('shopify:section:unload',e => {
      for (const [control,handlers] of carousels) if (e.target.contains(control)) { handlers.abort.abort(); handlers.resize.disconnect(); carousels.delete(control); }
      e.target.querySelectorAll('[data-th-delay]').forEach(el => observer?.unobserve(el));
      refreshMedia();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(),{once:true}); else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
